import { j as e } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as o, Link as t } from "@mui/joy";
import { memo as a } from "react";
import { S as n } from "../../../../../../index.B-E4PB3F.js";
const s = a(({
  syncDirection: r
}) => /* @__PURE__ */ e.jsx(o, { children: r === n.IMPORT ? /* @__PURE__ */ e.jsxs("span", { children: [
  "This will import the contents of any table or query data unloaded to a Snowflake stage, and store it as a dataset in the Decentriq platform. Note: please",
  /* @__PURE__ */ e.jsx(t, { color: "primary", href: "https://docs.decentriq.com/data-management/import/from-external-source/supported-sources#snowflake", level: "inherit", rel: "noreferrer", target: "_blank", underline: "hover", children: "follow the instructions" }),
  " ",
  "to prepare your data for import."
] }) : null }));
s.displayName = "SnowflakeInfo";
export {
  s as default
};
//# sourceMappingURL=SnowflakeInfo.js.map
